import React, { useState } from "react";
import { motion } from "framer-motion";
import {
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
  FaWhatsapp,
  FaTwitter,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaRegClock
} from "react-icons/fa";
import "./ContactUs.css";
import '../App.css'
import Header from "./Header";

export default function ContactUs() {

  const iconList = [
    { id: "ig", icon: <FaInstagram />, href: "https://www.instagram.com/shak7.info?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D" },
    { id: "fb", icon: <FaFacebookF />, href: "https://www.facebook.com/profile.php?id=61577990661651" },
    { id: "li", icon: <FaLinkedinIn />, href: "#" },
    { id: "wa", icon: <FaWhatsapp />, href: "#" },
  ];

  return (
    <section className="cu-outer" aria-label="Contact us section">
      <Header />
      {/* Animated blobs / particle layer */}
      <div className="cu-blob blob1" />
      <div className="cu-blob blob2" />
      <div className="cu-particles" />

      <div className="cu-container">
        {/* HERO */}
        <motion.div
          className="cu-hero"
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <h1 className="cu-title">Contact Us</h1>
          <p className="cu-sub">Let’s connect and grow together.</p>
          <div className="cu-hero-lines">
            <span className="line" />
            <span className="dot" />
            <span className="line " />
          </div>
        </motion.div>

        {/* MAIN GLASS CARD */}
        <div className="cu-grid">
          <motion.div
            className="cu-card cu-info"
            initial={{ opacity: 0, x: -60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
          >
            <h2 className="cu-card-title">Get in touch</h2>

            <div className="cu-contacts">
              <div className="cu-contact-row">
                <FaPhoneAlt className="ic" />
                <div>
                  <div className="label"></div>
                  <div className="value">+91 81281 88371</div>
                </div>
              </div>

              <div className="cu-contact-row">
                <FaEnvelope className="ic" />
                <div>
                  <div className="label"></div>
                  <div className="value">gamil.com</div>
                </div>
              </div>

              <div className="cu-contact-row">
                <FaMapMarkerAlt className="ic" />
                <div>
                  <div className="label"></div>
                  <div className="value">Jay Babari Complex, Surendranagar</div>
                </div>
              </div>

              <div className="cu-contact-row">
                <FaRegClock className="ic" />
                <div>
                  <div className="label"></div>
                  <div className="value">Mon–Sat: 9:00 — 20:00</div>
                </div>
              </div>
            </div>

            <h3 className="cu-card-title" style={{ marginTop: 20 }}>Follow us</h3>
            <div className="cu-social">
              {iconList.map((it) => (
                <motion.a
                  key={it.id}
                  href={it.href}
                  className="cu-social-btn"
                  whileHover={{ scale: 1.12, rotate: 8 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <span className="cu-social-inner">{it.icon}</span>
                  <span className="cu-pulse" />
                </motion.a>
              ))}
            </div>
          </motion.div>

          {/* MIDDLE: Map */}
          <motion.div
            className="cu-card cu-map"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="cu-map-wrap">
              {/* rounded glass map container */}
              <iframe
                title="office-map"
                className="cu-map-iframe"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3679.9265065494155!2d71.62391407785353!3d22.7309728740011!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x72a8ffd2b5247a5%3A0x839b2d28e8a78f01!2sShakti%20Education%20Institute!5e0!3m2!1sen!2sus!4v1765516317763!5m2!1sen!2sus"
                allowFullScreen
                loading="lazy"
              />
            </div>
          </motion.div>

          {/* RIGHT: Floating Form
          <motion.form
            className="cu-card cu-form"
            onSubmit={handleSubmit}
            initial={{ opacity: 0, x: 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
          >
            <h2 className="cu-card-title">Send us a message</h2>

            <div className="cu-field">
              <label>Name</label>
              <input
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Your name"
                required
              />
            </div>

            <div className="cu-field">
              <label>Email</label>
              <input
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
                placeholder="you@domain.com"
                required
              />
            </div>

            <div className="cu-field">
              <label>Message</label>
              <textarea
                name="message"
                value={form.message}
                onChange={handleChange}
                placeholder="How can we help?"
                rows="4"
                required
              />
            </div>

            <motion.button
              type="submit"
              className="cu-submit"
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
            >
              {sent ? "Sent ✓" : "Send Message"}
              <span className="cu-ripple" />
            </motion.button>
          </motion.form> */}
        </div>
      </div>
    </section>
  );
}
